import type {FC, SVGProps} from 'react'

export const SpinnerLight: FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <style>
      {`
        #octocat-spinner path {
          fill: #000;
          opacity: .28;
        }
        #octocat-spinner [class^="circle"] {
          animation: octocat-spinner-spin 1.6s infinite linear;
        }
        @keyframes octocat-spinner-spin {
          0% {
            opacity:1;
          }
          26%, 100% {
            opacity: .28;
          }
        }
        #octocat-spinner .circle-2 { animation-delay: .2s; }
        #octocat-spinner .circle-3 { animation-delay: .4s; }
        #octocat-spinner .circle-4 { animation-delay: .6s; }
        #octocat-spinner .circle-5 { animation-delay: .8s; }
        #octocat-spinner .circle-6 { animation-delay: 1s; }
        #octocat-spinner .circle-7 { animation-delay: 1.2s; }
        #octocat-spinner .circle-8 { animation-delay: 1.4s; }
      `}
    </style>
    <g id="octocat-spinner">
      <path
        className="mona"
        d="M19.7729 27.7255C18.572 28.0578 17.3067 28.2353 16 28.2353C14.7088 28.2353 13.458 28.0619 12.2697 27.7372C12.2642 27.1885 12.2564 26.4082 12.2564 25.5967C8.47169 26.2934 7.49257 24.674 7.1913 23.8267C7.02183 23.3936 6.28749 22.0568 5.64729 21.699C5.12006 21.4166 4.36689 20.7199 5.62846 20.701C6.81471 20.6822 7.66203 21.7931 7.94447 22.2451C9.30019 24.5234 11.4656 23.8832 12.3317 23.4878C12.4635 22.5087 12.8589 21.8496 13.292 21.473C9.94039 21.0965 6.43812 19.7972 6.43812 14.0354C6.43812 12.3973 7.02183 11.0416 7.98213 9.98713C7.83149 9.61054 7.30427 8.06654 8.13276 5.9953C8.13276 5.9953 9.39433 5.59989 12.2752 7.53931C13.4803 7.20038 14.7607 7.03092 16.0411 7.03092C17.3215 7.03092 18.6019 7.20038 19.807 7.53931C22.6879 5.58106 23.9494 5.9953 23.9494 5.9953C24.7779 8.06654 24.2507 9.61054 24.1001 9.98713C25.0604 11.0416 25.6441 12.3785 25.6441 14.0354C25.6441 19.8161 22.123 21.0965 18.7714 21.473C19.3174 21.9438 19.7881 22.8476 19.7881 24.2598C19.7881 25.6006 19.7798 26.7664 19.7742 27.546C19.7738 27.6084 19.7734 27.6682 19.7729 27.7255Z"
      />
      <path
        className="circle-8"
        d="M9.59052 3.41738C6.93928 4.77096 4.77099 6.93926 3.4174 9.5905L1.74091 8.73457C3.27477 5.73021 5.73024 3.27475 8.73459 1.74088L9.59052 3.41738Z"
      />
      <path
        className="circle-7"
        d="M0.779117 11.054C0.273347 12.6115 0 14.2738 0 16C0 17.7262 0.273347 19.3885 0.779116 20.946L2.56944 20.3646C2.1239 18.9926 1.88235 17.5263 1.88235 16C1.88235 14.4737 2.1239 13.0074 2.56944 11.6354L0.779117 11.054Z"
      />
      <path
        className="circle-6"
        d="M1.74091 23.2654L3.4174 22.4095C4.77099 25.0607 6.93928 27.229 9.59052 28.5826L8.73459 30.2591C5.73024 28.7253 3.27477 26.2698 1.74091 23.2654Z"
      />
      <path
        className="circle-5"
        d="M11.6353 29.4306C13.0074 29.8761 14.4736 30.1176 16 30.1176C17.5263 30.1176 18.9926 29.8761 20.3646 29.4306L20.946 31.2209C19.3885 31.7267 17.7261 32 16 32C14.2738 32 12.6115 31.7267 11.054 31.2209L11.6353 29.4306Z"
      />
      <path
        className="circle-4"
        d="M22.4095 28.5826C25.0607 27.229 27.229 25.0607 28.5826 22.4095L30.2591 23.2654C28.7252 26.2698 26.2698 28.7253 23.2654 30.2591L22.4095 28.5826Z"
      />
      <path
        className="circle-3"
        d="M29.4305 20.3646C29.8761 18.9926 30.1176 17.5263 30.1176 16C30.1176 14.4737 29.8761 13.0074 29.4305 11.6354L31.2209 11.054C31.7266 12.6115 32 14.2738 32 16C32 17.7262 31.7266 19.3885 31.2209 20.946L29.4305 20.3646Z"
      />
      <path
        className="circle-2"
        d="M28.5826 9.5905C27.229 6.93926 25.0607 4.77096 22.4095 3.41738L23.2654 1.74088C26.2698 3.27475 28.7252 5.73021 30.2591 8.73457L28.5826 9.5905Z"
      />
      <path
        className="circle-1"
        d="M20.3646 2.56944C18.9926 2.1239 17.5263 1.88235 16 1.88235C14.4736 1.88235 13.0074 2.1239 11.6353 2.56944L11.054 0.779116C12.6115 0.273347 14.2738 0 16 0C17.7261 0 19.3885 0.273347 20.946 0.779117L20.3646 2.56944Z"
      />
    </g>
  </svg>
)

export const SpinnerDark: FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <style>
      {`
        #octocat-spinner path {
          fill: #fff;
          opacity: .3;
        }
        #octocat-spinner [class^="circle"] {
          animation: octocat-spinner-spin 1.6s infinite linear;
        }
        @keyframes octocat-spinner-spin {
          0% {
            opacity:1;
          }
          26%, 100% {
            opacity: .3;
          }
        }
        #octocat-spinner .circle-2 { animation-delay: .2s; }
        #octocat-spinner .circle-3 { animation-delay: .4s; }
        #octocat-spinner .circle-4 { animation-delay: .6s; }
        #octocat-spinner .circle-5 { animation-delay: .8s; }
        #octocat-spinner .circle-6 { animation-delay: 1s; }
        #octocat-spinner .circle-7 { animation-delay: 1.2s; }
        #octocat-spinner .circle-8 { animation-delay: 1.4s; }
      `}
    </style>
    <g id="octocat-spinner">
      <path
        className="mona"
        d="M19.7729 27.7255C18.572 28.0578 17.3067 28.2353 16 28.2353C14.7088 28.2353 13.458 28.0619 12.2697 27.7372C12.2642 27.1885 12.2564 26.4082 12.2564 25.5967C8.47169 26.2934 7.49257 24.674 7.1913 23.8267C7.02183 23.3936 6.28749 22.0568 5.64729 21.699C5.12006 21.4166 4.36689 20.7199 5.62846 20.701C6.81471 20.6822 7.66203 21.7931 7.94447 22.2451C9.30019 24.5234 11.4656 23.8832 12.3317 23.4878C12.4635 22.5087 12.8589 21.8496 13.292 21.473C9.94039 21.0965 6.43812 19.7972 6.43812 14.0354C6.43812 12.3973 7.02183 11.0416 7.98213 9.98713C7.83149 9.61054 7.30427 8.06654 8.13276 5.9953C8.13276 5.9953 9.39433 5.59989 12.2752 7.53931C13.4803 7.20038 14.7607 7.03092 16.0411 7.03092C17.3215 7.03092 18.6019 7.20038 19.807 7.53931C22.6879 5.58106 23.9494 5.9953 23.9494 5.9953C24.7779 8.06654 24.2507 9.61054 24.1001 9.98713C25.0604 11.0416 25.6441 12.3785 25.6441 14.0354C25.6441 19.8161 22.123 21.0965 18.7714 21.473C19.3174 21.9438 19.7881 22.8476 19.7881 24.2598C19.7881 25.6006 19.7798 26.7664 19.7742 27.546C19.7738 27.6084 19.7734 27.6682 19.7729 27.7255Z"
      />
      <path
        className="circle-8"
        d="M9.59052 3.41738C6.93928 4.77096 4.77099 6.93926 3.4174 9.5905L1.74091 8.73457C3.27477 5.73021 5.73024 3.27475 8.73459 1.74088L9.59052 3.41738Z"
      />
      <path
        className="circle-7"
        d="M0.779117 11.054C0.273347 12.6115 0 14.2738 0 16C0 17.7262 0.273347 19.3885 0.779116 20.946L2.56944 20.3646C2.1239 18.9926 1.88235 17.5263 1.88235 16C1.88235 14.4737 2.1239 13.0074 2.56944 11.6354L0.779117 11.054Z"
      />
      <path
        className="circle-6"
        d="M1.74091 23.2654L3.4174 22.4095C4.77099 25.0607 6.93928 27.229 9.59052 28.5826L8.73459 30.2591C5.73024 28.7253 3.27477 26.2698 1.74091 23.2654Z"
      />
      <path
        className="circle-5"
        d="M11.6353 29.4306C13.0074 29.8761 14.4736 30.1176 16 30.1176C17.5263 30.1176 18.9926 29.8761 20.3646 29.4306L20.946 31.2209C19.3885 31.7267 17.7261 32 16 32C14.2738 32 12.6115 31.7267 11.054 31.2209L11.6353 29.4306Z"
      />
      <path
        className="circle-4"
        d="M22.4095 28.5826C25.0607 27.229 27.229 25.0607 28.5826 22.4095L30.2591 23.2654C28.7252 26.2698 26.2698 28.7253 23.2654 30.2591L22.4095 28.5826Z"
      />
      <path
        className="circle-3"
        d="M29.4305 20.3646C29.8761 18.9926 30.1176 17.5263 30.1176 16C30.1176 14.4737 29.8761 13.0074 29.4305 11.6354L31.2209 11.054C31.7266 12.6115 32 14.2738 32 16C32 17.7262 31.7266 19.3885 31.2209 20.946L29.4305 20.3646Z"
      />
      <path
        className="circle-2"
        d="M28.5826 9.5905C27.229 6.93926 25.0607 4.77096 22.4095 3.41738L23.2654 1.74088C26.2698 3.27475 28.7252 5.73021 30.2591 8.73457L28.5826 9.5905Z"
      />
      <path
        className="circle-1"
        d="M20.3646 2.56944C18.9926 2.1239 17.5263 1.88235 16 1.88235C14.4736 1.88235 13.0074 2.1239 11.6353 2.56944L11.054 0.779116C12.6115 0.273347 14.2738 0 16 0C17.7261 0 19.3885 0.273347 20.946 0.779117L20.3646 2.56944Z"
      />
    </g>
  </svg>
)
